export default __webpack_public_path__ + "static/media/X_Xaina.d28d5897.svg";